import store from '../store'

export async function setViewToDashboard() {
  await store.commit('SET_CURRENT_VIEW', { view: 'dashboard' })
}
export async function setViewToDroneview() {
  await store.commit('SET_CURRENT_VIEW', { view: 'droneview' })
}
export async function setViewToIndoorview() {
  await store.commit('SET_CURRENT_VIEW', { view: 'indoorview' })
}
export async function setViewToMapview() {
  await store.commit('SET_CURRENT_VIEW', { view: 'mapview' })
}
export async function setViewToModelview() {
  await store.commit('SET_CURRENT_VIEW', { view: 'modelview' })
}
export async function setViewToPlanview() {
  await store.commit('SET_CURRENT_VIEW', { view: 'planview' })
}

export async function setViewToPreviousView(previousView) {
  switch (previousView) {
    case 'dashboard':
      return await setViewToDashboard()
    case 'droneview':
      return await setViewToDroneview()
    case 'indoorview':
      return await setViewToIndoorview()
    case 'mapview':
      return await setViewToMapview()
    case 'modelview':
      return await setViewToModelview()
    case 'planview':
      return await setViewToPlanview()
  }
}
